// ** react imports
import React from 'react';

const TermsAndConditions = () => {
  // SVG Logo Component
  const LogoSVG = () => (
    <span
      className="logo"
      style={{
        display: 'block',
        margin: '0 auto 3.125rem',
        width: '11.125rem',
        height: '2.375rem',
        background:
          'url(data:image/svg+xml;base64,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) center no-repeat;',
      }}
    />
  );

  // Inline styles for different elements
  const bodyStyle = {
    backgroundColor: 'transparent',
  };

  const titleStyle = {
    fontFamily: 'Arial',
    fontSize: '26px',
    color: '#000000',
    lineHeight: '1.5',
    fontWeight: 'bold',
  };

  const subtitleStyle = {
    fontFamily: 'Arial',
    color: '#595959',
    fontSize: '14px',
    lineHeight: '1.5',
    fontWeight: 'bold',
  };

  const heading1Style = {
    fontFamily: 'Arial',
    fontSize: '19px',
    color: '#000000',
    lineHeight: '1.5',
    fontWeight: 'bold',
  };

  const heading2Style = {
    fontFamily: 'Arial',
    fontSize: '17px',
    color: '#000000',
    lineHeight: '1.5',
    fontWeight: 'bold',
  };

  const bodyTextStyle = {
    color: '#595959',
    fontSize: '14px',
    fontFamily: 'Arial',
    lineHeight: '1.5',
  };

  const linkStyle = {
    color: '#3030f1',
    fontSize: '14px',
    fontFamily: 'Arial',
    wordBreak: 'break-word',
    textDecoration: 'underline',
  };

  const listStyle = {
    listStyleType: 'square',
    marginLeft: '20px',
  };

  const nestedListStyle = {
    listStyleType: 'circle',
    marginLeft: '20px',
  };

  const doubleNestedListStyle = {
    listStyleType: 'square',
    marginLeft: '20px',
  };

  const orderedListStyle = {
    fontFamily: 'Arial',
    marginLeft: '20px',
  };

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '20px' }}>
      <LogoSVG />

      <div style={bodyStyle}>
        <div style={{ textAlign: 'left' }}>
          <div className="MsoNormal" style={titleStyle}>
            <strong>
              <h1>TERMS AND CONDITIONS</h1>
            </strong>
          </div>

          <div className="MsoNormal" style={subtitleStyle}>
            <strong>Last updated</strong> October 17, 2025
          </div>

          <div className="MsoNormal" style={{ lineHeight: '1.1' }}>
            <br />
          </div>
          <div style={{ lineHeight: '1.5' }}>
            <br />
          </div>

          <div style={{ lineHeight: '1.5' }}>
            <strong>
              <span style={heading1Style}>
                <h2>AGREEMENT TO OUR LEGAL TERMS</h2>
              </span>
            </strong>
          </div>
        </div>

        <div style={{ textAlign: 'left' }}>
          <div
            className="MsoNormal"
            id="agreement"
            style={{ lineHeight: '1.5' }}
          >
            <a name="_6aa3gkhykvst"></a>
          </div>
        </div>

        <div style={{ textAlign: 'left' }}>
          <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
            <br />
          </div>

          <div className="MsoNormal" style={bodyTextStyle}>
            We are MultiTax, doing business as Multitax Financial Solutions
            (Company, we, us, our) a company registered in Nevada, United States
            at 5645 S Eastern Ave Suite 5, Las Vegas, NV 89119.
          </div>

          <div className="MsoNormal" style={{ lineHeight: '1.1' }}>
            <br />
          </div>

          <div className="MsoNormal" style={bodyTextStyle}>
            We operate the mobile application MultiTax (the App), as well as any
            other related products and services that refer or link to these
            legal terms (the Legal Terms) (collectively, the Services).
          </div>

          <div className="MsoNormal" style={{ lineHeight: '1.1' }}>
            <br />
          </div>

          <div className="MsoNormal" style={bodyTextStyle}>
            You can contact us by phone at (+1)7023376272, email at
            <a href="mailto:multitaxpreparation@gmail.com" style={linkStyle}>
              multitaxpreparation@gmail.com
            </a>
            , or by mail to 1725 S Rainbow Blvd suite 19, Las Vegas, NV 89146,
            USA.
          </div>

          <div className="MsoNormal" style={{ lineHeight: '1.1' }}>
            <br />
          </div>

          <div className="MsoNormal" style={bodyTextStyle}>
            These Legal Terms constitute a legally binding agreement made
            between you, whether personally or on behalf of an entity (you), and
            MultiTax, concerning your access to and use of the Services. You
            agree that by accessing the Services, you have read, understood, and
            agreed to be bound by all of these Legal Terms. IF YOU DO NOT AGREE
            WITH ALL OF THESE LEGAL TERMS, THEN YOU ARE EXPRESSLY PROHIBITED
            FROM USING THE SERVICES AND YOU MUST DISCONTINUE USE IMMEDIATELY.
          </div>

          <div className="MsoNormal" style={{ lineHeight: '1.1' }}>
            <br />
          </div>

          <div className="MsoNormal" style={bodyTextStyle}>
            We will provide you with prior notice of any scheduled changes to
            the Services you are using. The modified Legal Terms will become
            effective upon posting or notifying you by
            <a href="mailto:info@multitaxx.com" style={linkStyle}>
              info@multitaxx.com
            </a>
            , as stated in the email message. By continuing to use the Services
            after the effective date of any changes, you agree to be bound by
            the modified terms.
          </div>
        </div>

        <div style={{ lineHeight: '1.1' }}>
          <br />
        </div>

        <div style={{ textAlign: 'left' }}>
          <div className="MsoNormal" style={bodyTextStyle}>
            The Services are intended for users who are at least 18 years old.
            Persons under the age of 18 are not permitted to use or register for
            the Services.
          </div>

          <div className="MsoNormal" style={{ lineHeight: '1.1' }}>
            <br />
          </div>

          <div className="MsoNormal" style={bodyTextStyle}>
            We recommend that you print a copy of these Legal Terms for your
            records.
          </div>

          <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
            <br />
          </div>

          <div className="MsoNormal" style={heading1Style}>
            <strong>
              <h2>TABLE OF CONTENTS</h2>
            </strong>
          </div>

          <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
            <a href="#services" style={linkStyle}>
              1. OUR SERVICES
            </a>
          </div>
          <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
            <a href="#ip" style={linkStyle}>
              2. INTELLECTUAL PROPERTY RIGHTS
            </a>
          </div>
          <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
            <a href="#userreps" style={linkStyle}>
              3. USER REPRESENTATIONS
            </a>
          </div>
          <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
            <a href="#userreg" style={linkStyle}>
              4. USER REGISTRATION
            </a>
          </div>
          <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
            <a href="#prohibited" style={linkStyle}>
              5. PROHIBITED ACTIVITIES
            </a>
          </div>
          <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
            <a href="#ugc" style={linkStyle}>
              6. USER GENERATED CONTRIBUTIONS
            </a>
          </div>
          <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
            <a href="#license" style={linkStyle}>
              7. CONTRIBUTION LICENSE
            </a>
          </div>
          <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
            <a href="#mobile" style={linkStyle}>
              8. MOBILE APPLICATION LICENSE
            </a>
          </div>
          <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
            <a href="#sitemanage" style={linkStyle}>
              9. SERVICES MANAGEMENT
            </a>
          </div>
          <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
            <a href="#ppno" style={linkStyle}>
              10. PRIVACY POLICY
            </a>
          </div>
          <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
            <a href="#terms" style={linkStyle}>
              11. TERM AND TERMINATION
            </a>
          </div>
          <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
            <a href="#modifications" style={linkStyle}>
              12. MODIFICATIONS AND INTERRUPTIONS
            </a>
          </div>
          <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
            <a href="#law" style={linkStyle}>
              13. GOVERNING LAW
            </a>
          </div>
          <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
            <a href="#disputes" style={linkStyle}>
              14. DISPUTE RESOLUTION
            </a>
          </div>
          <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
            <a href="#corrections" style={linkStyle}>
              15. CORRECTIONS
            </a>
          </div>
          <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
            <a href="#disclaimer" style={linkStyle}>
              16. DISCLAIMER
            </a>
          </div>
          <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
            <a href="#liability" style={linkStyle}>
              17. LIMITATIONS OF LIABILITY
            </a>
          </div>
          <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
            <a href="#indemnification" style={linkStyle}>
              18. INDEMNIFICATION
            </a>
          </div>
          <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
            <a href="#userdata" style={linkStyle}>
              19. USER DATA
            </a>
          </div>
          <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
            <a href="#electronic" style={linkStyle}>
              20. ELECTRONIC COMMUNICATIONS, TRANSACTIONS, AND SIGNATURES
            </a>
          </div>
          <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
            <a href="#california" style={linkStyle}>
              21. CALIFORNIA USERS AND RESIDENTS
            </a>
          </div>
          <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
            <a href="#misc" style={linkStyle}>
              22. MISCELLANEOUS
            </a>
          </div>
          <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
            <a href="#contact" style={linkStyle}>
              23. CONTACT US
            </a>
          </div>
        </div>

        <div style={{ textAlign: 'left' }}>
          <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
            <br />
          </div>

          <div className="MsoNormal" id="services" style={heading1Style}>
            <strong>
              <span style={{ fontSize: '19px', lineHeight: '1.5' }}>
                <h2>1. OUR SERVICES</h2>
              </span>
            </strong>
          </div>

          <div className="MsoNormal" style={bodyTextStyle}>
            The information provided when using the Services is not intended for
            distribution to or use by any person or entity in any jurisdiction
            or country where such distribution or use would be contrary to law
            or regulation or which would subject us to any registration
            requirement within such jurisdiction or country. Accordingly, those
            persons who choose to access the Services from other locations do so
            on their own initiative and are solely responsible for compliance
            with local laws, if and to the extent local laws are applicable.
          </div>

          <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
            <br />
          </div>

          <div className="MsoNormal" style={bodyTextStyle}>
            Data Protection Law
          </div>

          <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
            <br />
          </div>
        </div>

        <div style={{ textAlign: 'left', lineHeight: '1.5' }}>
          <strong>
            <span id="ip" style={{ fontSize: '19px', lineHeight: '1.5' }}>
              <h2>2. INTELLECTUAL PROPERTY RIGHTS</h2>
            </span>
          </strong>
        </div>

        <div style={{ textAlign: 'left' }}>
          <div className="MsoNormal" style={heading2Style}>
            <strong>
              <h3>Our intellectual property</h3>
            </strong>
          </div>

          <div className="MsoNormal" style={bodyTextStyle}>
            We are the owner or the licensee of all intellectual property rights
            in our Services, including all source code, databases,
            functionality, software, website designs, audio, video, text,
            photographs, and graphics in the Services (collectively, the
            Content), as well as the trademarks, service marks, and logos
            contained therein (the Marks).
          </div>

          <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
            <br />
          </div>

          <div className="MsoNormal" style={bodyTextStyle}>
            Our Content and Marks are protected by copyright and trademark laws
            (and various other intellectual property rights and unfair
            competition laws) and treaties in the United States and around the
            world.
          </div>

          <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
            <br />
          </div>

          <div className="MsoNormal" style={bodyTextStyle}>
            The Content and Marks are provided in or through the Services AS IS
            for your personal, non-commercial use or internal business purpose
            only.
          </div>

          <div className="MsoNormal" style={heading2Style}>
            <strong>
              <h3>Your use of our Services</h3>
            </strong>
          </div>

          <div className="MsoNormal" style={bodyTextStyle}>
            Subject to your compliance with these Legal Terms, including the
            PROHIBITED ACTIVITIES section below, we grant you a non-exclusive,
            non-transferable, revocable license to:
          </div>

          <ul style={listStyle}>
            <li className="MsoNormal" style={bodyTextStyle}>
              access the Services; and
            </li>
            <li className="MsoNormal" style={bodyTextStyle}>
              download or print a copy of any portion of the Content to which
              you have properly gained access,
            </li>
          </ul>

          <div className="MsoNormal" style={bodyTextStyle}>
            solely for your personal, non-commercial use or internal business
            purpose.
          </div>

          <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
            <br />
          </div>

          <div className="MsoNormal" style={bodyTextStyle}>
            Except as set out in this section or elsewhere in our Legal Terms,
            no part of the Services and no Content or Marks may be copied,
            reproduced, aggregated, republished, uploaded, posted, publicly
            displayed, encoded, translated, transmitted, distributed, sold,
            licensed, or otherwise exploited for any commercial purpose
            whatsoever, without our express prior written permission.
          </div>

          <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
            <br />
          </div>

          <div className="MsoNormal" style={bodyTextStyle}>
            If you wish to make any use of the Services, Content, or Marks other
            than as set out in this section or elsewhere in our Legal Terms,
            please address your request to:
            <a href="mailto:multitaxpreparation@gmail.com" style={linkStyle}>
              multitaxpreparation@gmail.com
            </a>
            . If we ever grant you the permission to post, reproduce, or
            publicly display any part of our Services or Content, you must
            identify us as the owners or licensors of the Services, Content, or
            Marks and ensure that any copyright or proprietary notice appears or
            is visible on posting, reproducing, or displaying our Content.
          </div>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div style={{ textAlign: 'left' }}>
          <div className="MsoNormal" style={bodyTextStyle}>
            We reserve all rights not expressly granted to you in and to the
            Services, Content, and Marks.
          </div>

          <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
            <br />
          </div>

          <div className="MsoNormal" style={bodyTextStyle}>
            Any breach of these Intellectual Property Rights will constitute a
            material breach of our Legal Terms and your right to use our
            Services will terminate immediately.
          </div>

          <div className="MsoNormal" style={heading2Style}>
            <span
              style={{
                lineHeight: '1.5',
                fontFamily: 'Arial',
                fontSize: '17px',
              }}
            >
              <strong>
                <h3>Your submissions and contributions</h3>
              </strong>
            </span>
          </div>

          <div className="MsoNormal" style={bodyTextStyle}>
            Please review this section and the PROHIBITED ACTIVITIES section
            carefully prior to using our Services to understand the (a) rights
            you give us and (b) obligations you have when you post or upload any
            content through the Services.
          </div>

          <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
            <br />
          </div>

          <div className="MsoNormal" style={bodyTextStyle}>
            <strong>Submissions:</strong> By directly sending us any question,
            comment, suggestion, idea, feedback, or other information about the
            Services (Submissions), you agree to assign to us all intellectual
            property rights in such Submission. You agree that we shall own this
            Submission and be entitled to its unrestricted use and dissemination
            for any lawful purpose, commercial or otherwise, without
            acknowledgment or compensation to you.
          </div>

          <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
            <br />
          </div>

          <div className="MsoNormal" style={bodyTextStyle}>
            <strong>Contributions:</strong> The Services may invite you to chat,
            contribute to, or participate in blogs, message boards, online
            forums, and other functionality during which you may create, submit,
            post, display, transmit, publish, distribute, or broadcast content
            and materials to us or through the Services, including but not
            limited to text, writings, video, audio, photographs, music,
            graphics, comments, reviews, rating suggestions, personal
            information, or other material (Contributions). Any Submission that
            is publicly posted shall also be treated as a Contribution.
          </div>

          <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
            <br />
          </div>

          <div className="MsoNormal" style={bodyTextStyle}>
            You understand that Contributions may be viewable by other users of
            the Services.
          </div>

          <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
            <br />
          </div>

          <div className="MsoNormal" style={bodyTextStyle}>
            <strong>
              When you post Contributions, you grant us a license (including use
              of your name, trademarks, and logos):
            </strong>{' '}
            By posting any Contributions, you grant us an unrestricted,
            unlimited, irrevocable, perpetual, non-exclusive, transferable,
            royalty-free, fully-paid, worldwide right, and license to: use,
            copy, reproduce, distribute, sell, resell, publish, broadcast,
            retitle, store, publicly perform, publicly display, reformat,
            translate, excerpt (in whole or in part), and exploit your
            Contributions (including, without limitation, your image, name, and
            voice) for any purpose, commercial, advertising, or otherwise, to
            prepare derivative works of, or incorporate into other works, your
            Contributions, and to sublicense the licenses granted in this
            section. Our use and distribution may occur in any media formats and
            through any media channels.
          </div>

          <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
            <br />
          </div>

          <div className="MsoNormal" style={bodyTextStyle}>
            This license includes our use of your name, company name, and
            franchise name, as applicable, and any of the trademarks, service
            marks, trade names, logos, and personal and commercial images you
            provide.
          </div>

          <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
            <br />
          </div>

          <div className="MsoNormal" style={bodyTextStyle}>
            <strong>You are responsible for what you post or upload:</strong> By
            sending us Submissions and/or posting Contributions through any part
            of the Services or making Contributions accessible through the
            Services by linking your account through the Services to any of your
            social networking accounts, you:
          </div>

          <ul style={listStyle}>
            <li className="MsoNormal" style={bodyTextStyle}>
              confirm that you have read and agree with our PROHIBITED
              ACTIVITIES and will not post, send, publish, upload, or transmit
              through the Services any Submission nor post any Contribution that
              is illegal, harassing, hateful, harmful, defamatory, obscene,
              bullying, abusive, discriminatory, threatening to any person or
              group, sexually explicit, false, inaccurate, deceitful, or
              misleading;
            </li>
            <li className="MsoNormal" style={bodyTextStyle}>
              to the extent permissible by applicable law, waive any and all
              moral rights to any such Submission and/or Contribution;
            </li>
            <li className="MsoNormal" style={bodyTextStyle}>
              warrant that any such Submission and/or Contributions are original
              to you or that you have the necessary rights and licenses to
              submit such Submissions and/or Contributions and that you have
              full authority to grant us the above-mentioned rights in relation
              to your Submissions and/or Contributions; and
            </li>
            <li className="MsoNormal" style={bodyTextStyle}>
              warrant and represent that your Submissions and/or Contributions
              do not constitute confidential information.
            </li>
          </ul>

          <div className="MsoNormal" style={bodyTextStyle}>
            You are solely responsible for your Submissions and/or Contributions
            and you expressly agree to reimburse us for any and all losses that
            we may suffer because of your breach of (a) this section, (b) any
            third party&apos;s intellectual property rights, or (c) applicable
            law.
          </div>

          <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
            <br />
          </div>

          <div className="MsoNormal" style={bodyTextStyle}>
            <strong>We may remove or edit your Content:</strong> Although we
            have no obligation to monitor any Contributions, we shall have the
            right to remove or edit any Contributions at any time without notice
            if in our reasonable opinion we consider such Contributions harmful
            or in breach of these Legal Terms. If we remove or edit any such
            Contributions, we may also suspend or disable your account and
            report you to the authorities.
          </div>

          <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
            <br />
          </div>
        </div>

        <div style={{ textAlign: 'left' }}>
          <div className="MsoNormal" id="userreps" style={heading1Style}>
            <a name="_5hg7kgyv9l8z"></a>
            <strong>
              <span
                style={{
                  lineHeight: '1.5',
                  fontFamily: 'Arial',
                  fontSize: '19px',
                }}
              >
                <h2>3. USER REPRESENTATIONS</h2>
              </span>
            </strong>
          </div>
        </div>

        <div style={{ textAlign: 'left' }}>
          <div className="MsoNormal" style={bodyTextStyle}>
            By using the Services, you represent and warrant that: (1) all
            registration information you submit will be true, accurate, current,
            and complete; (2) you will maintain the accuracy of such information
            and promptly update such registration information as necessary; (3)
            you have the legal capacity and you agree to comply with these Legal
            Terms; (4) you are not a minor in the jurisdiction in which you
            reside; (5) you will not access the Services through automated or
            non-human means, whether through a bot, script or otherwise; (6) you
            will not use the Services for any illegal or unauthorized purpose;
            and (7) your use of the Services will not violate any applicable law
            or regulation.
          </div>
        </div>

        <div style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div style={{ textAlign: 'left' }}>
          <div
            className="MsoNormal"
            style={{ textAlign: 'justify', lineHeight: '1.15' }}
          >
            <div className="MsoNormal" style={{ lineHeight: '17.25px' }}>
              <div
                className="MsoNormal"
                style={{ lineHeight: '1.5', textAlign: 'left' }}
              >
                <span
                  style={{
                    fontSize: '1pt',
                    lineHeight: '16.8667px',
                    color: 'rgb(89, 89, 89)',
                  }}
                >
                  If you provide any information that is untrue, inaccurate, not
                  current, or incomplete, we have the right to suspend or
                  terminate your account and refuse any and all current or
                  future use of the Services (or any portion thereof).
                </span>
              </div>
              <div
                className="MsoNormal"
                style={{ lineHeight: '1.1', textAlign: 'left' }}
              >
                <br />
              </div>
              <div
                className="MsoNormal"
                style={{ lineHeight: '1.5', textAlign: 'left' }}
              >
                <br />
              </div>
            </div>

            <div className="MsoNormal" style={{ lineHeight: '1' }}>
              <div className="MsoNormal" id="userreg" style={heading1Style}>
                <strong>
                  <span style={{ lineHeight: '1.5', fontSize: '19px' }}>
                    <h2>4. USER REGISTRATION</h2>
                  </span>
                </strong>
              </div>
            </div>

            <div className="MsoNormal" style={{ lineHeight: '1' }}>
              <div
                className="MsoNormal"
                style={{ textAlign: 'left', lineHeight: '1.5' }}
              >
                <span
                  style={{
                    fontSize: '11pt',
                    lineHeight: '16.8667px',
                    color: 'rgb(89, 89, 89)',
                  }}
                >
                  You may be required to register to use the Services. You agree
                  to keep your password confidential and will be responsible for
                  all use of your account and password. We reserve the right to
                  remove, reclaim, or change a username you select if we
                  determine, in our sole discretion, that such username is
                  inappropriate, obscene, or otherwise objectionable.
                </span>
              </div>
            </div>

            <div
              className="MsoNormal"
              style={{ lineHeight: '1.5', textAlign: 'left' }}
            >
              <br />
            </div>
            <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
              <br />
            </div>
            <div
              className="MsoNormal"
              style={{ textAlign: 'justify', lineHeight: '1.5' }}
            >
              <br />
            </div>

            <div
              className="MsoNormal"
              id="prohibited"
              style={{ textAlign: 'left', lineHeight: '1.5' }}
            >
              <strong>
                <span style={{ lineHeight: '1.5', fontSize: '19px' }}>
                  <h2>5. PROHIBITED ACTIVITIES</h2>
                </span>
              </strong>
            </div>
          </div>
        </div>

        <div
          className="MsoNormal"
          style={{ textAlign: 'justify', lineHeight: '1' }}
        >
          <div
            className="MsoNormal"
            style={{ lineHeight: '1.5', textAlign: 'left' }}
          >
            <span
              style={{
                fontSize: '11pt',
                lineHeight: '16.8667px',
                color: 'rgb(89, 89)',
              }}
            >
              You may not access or use the Services for any purpose other than
              that for which we make the Services available. The Services may
              not be used in connection with any commercial endeavors except
              those that are specifically endorsed or approved by us.
            </span>
          </div>
        </div>

        <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div
          className="MsoNormal"
          style={{ textAlign: 'justify', lineHeight: '1' }}
        >
          <div className="MsoNormal" style={{ lineHeight: '17.25px' }}>
            <div className="MsoNormal" style={{ lineHeight: '1.1' }}>
              <br />
            </div>
            <div className="MsoNormal" style={{ lineHeight: '17.25px' }}>
              <div
                className="MsoNormal"
                style={{ lineHeight: '1.5', textAlign: 'left' }}
              >
                <span
                  style={{
                    fontSize: '11pt',
                    lineHeight: '16.8667px',
                    color: 'rgb(89, 89, 89)',
                  }}
                >
                  As a user of the Services, you agree not to:
                </span>
              </div>
            </div>

            <ul style={listStyle}>
              <li
                className="MsoNormal"
                style={{ lineHeight: '1.5', textAlign: 'left' }}
              >
                <span
                  style={{
                    fontSize: '11pt',
                    lineHeight: '16.8667px',
                    color: 'rgb(89, 89, 89)',
                  }}
                >
                  Systematically retrieve data or other content from the
                  Services to create or compile, directly or indirectly, a
                  collection, compilation, database, or directory without
                  written permission from us.
                </span>
              </li>
              <li
                className="MsoNormal"
                style={{ lineHeight: '1.5', textAlign: 'left' }}
              >
                <span
                  style={{
                    fontSize: '15px',
                    lineHeight: '16.8667px',
                    color: 'rgb(89, 89, 89)',
                  }}
                >
                  Trick, defraud, or mislead us and other users, especially in
                  any attempt to learn sensitive account information such as
                  user passwords.
                </span>
              </li>
              <li
                className="MsoNormal"
                style={{ lineHeight: '1.5', textAlign: 'left' }}
              >
                <span
                  style={{
                    fontSize: '15px',
                    lineHeight: '16.8667px',
                    color: 'rgb(89, 89, 89)',
                  }}
                >
                  Circumvent, disable, or otherwise interfere with
                  security-related features of the Services, including features
                  that prevent or restrict the use or copying of any Content or
                  enforce limitations on the use of the Services and/or the
                  Content contained therein.
                </span>
              </li>
              <li
                className="MsoNormal"
                style={{ lineHeight: '1.5', textAlign: 'left' }}
              >
                <span
                  style={{
                    fontSize: '15px',
                    lineHeight: '16.8667px',
                    color: 'rgb(89, 89, 89)',
                  }}
                >
                  Disparage, tarnish, or otherwise harm, in our opinion, us
                  and/or the Services.
                </span>
              </li>
              <li
                className="MsoNormal"
                style={{ lineHeight: '1.5', textAlign: 'left' }}
              >
                <span
                  style={{
                    fontSize: '15px',
                    lineHeight: '16.8667px',
                    color: 'rgb(89, 89, 89)',
                  }}
                >
                  Use any information obtained from the Services in order to
                  harass, abuse, or harm another person.
                </span>
              </li>
              <li
                className="MsoNormal"
                style={{ lineHeight: '1.5', textAlign: 'left' }}
              >
                <span
                  style={{
                    fontSize: '15px',
                    lineHeight: '16.8667px',
                    color: 'rgb(89, 89, 89)',
                  }}
                >
                  Make improper use of our support services or submit false
                  reports of abuse or misconduct.
                </span>
              </li>
              <li
                className="MsoNormal"
                style={{ lineHeight: '1.5', textAlign: 'left' }}
              >
                <span
                  style={{
                    fontSize: '15px',
                    lineHeight: '16.8667px',
                    color: 'rgb(89, 89, 89)',
                  }}
                >
                  Use the Services in a manner inconsistent with any applicable
                  laws or regulations.
                </span>
              </li>
              <li
                className="MsoNormal"
                style={{ lineHeight: '1.5', textAlign: 'left' }}
              >
                <span
                  style={{
                    fontSize: '15px',
                    lineHeight: '16.8667px',
                    color: 'rgb(89, 89, 89)',
                  }}
                >
                  Engage in unauthorized framing of or linking to the Services.
                </span>
              </li>
              <li
                className="MsoNormal"
                style={{ lineHeight: '1.5', textAlign: 'left' }}
              >
                <span
                  style={{
                    fontSize: '15px',
                    lineHeight: '16.8667px',
                    color: 'rgb(89, 89, 89)',
                  }}
                >
                  Upload or transmit (or attempt to upload or to transmit)
                  viruses, Trojan horses, or other material, including excessive
                  use of capital letters and spamming (continuous posting of
                  repetitive text), that interferes with any party&apos;s
                  uninterrupted use and enjoyment of the Services or modifies,
                  impairs, disrupts, alters, or interferes with the use,
                  features, functions, operation, or maintenance of the
                  Services.
                </span>
              </li>
              <li
                className="MsoNormal"
                style={{ lineHeight: '1.5', textAlign: 'left' }}
              >
                <span
                  style={{
                    fontSize: '15px',
                    lineHeight: '16.8667px',
                    color: 'rgb(89, 89, 89)',
                  }}
                >
                  Engage in any automated use of the system, such as using
                  scripts to send comments or messages, or using any data
                  mining, robots, or similar data gathering and extraction
                  tools.
                </span>
              </li>
              <li
                className="MsoNormal"
                style={{ lineHeight: '1.5', textAlign: 'left' }}
              >
                <span
                  style={{
                    fontSize: '15px',
                    lineHeight: '16.8667px',
                    color: 'rgb(89, 89, 89)',
                  }}
                >
                  Delete the copyright or other proprietary rights notice from
                  any Content.
                </span>
              </li>
              <li
                className="MsoNormal"
                style={{ lineHeight: '1.5', textAlign: 'left' }}
              >
                <span
                  style={{
                    fontSize: '15px',
                    lineHeight: '16.8667px',
                    color: 'rgb(89, 89, 89)',
                  }}
                >
                  Attempt to impersonate another user or person or use the
                  username of another user.
                </span>
              </li>
              <li
                className="MsoNormal"
                style={{ lineHeight: '1.5', textAlign: 'left' }}
              >
                <span
                  style={{
                    fontSize: '15px',
                    lineHeight: '16.8667px',
                    color: 'rgb(89, 89, 89)',
                  }}
                >
                  Upload or transmit (or attempt to upload or to transmit) any
                  material that acts as a passive or active information
                  collection or transmission mechanism, including without
                  limitation, clear graphics interchange formats (gifs), 1×1
                  pixels, web bugs, cookies, or other similar devices (sometimes
                  referred to as spyware or passive collection mechanisms or
                  pcms).
                </span>
              </li>
              <li
                className="MsoNormal"
                style={{ lineHeight: '1.5', textAlign: 'left' }}
              >
                <span
                  style={{
                    fontSize: '15px',
                    lineHeight: '16.8667px',
                    color: 'rgb(89, 89, 89)',
                  }}
                >
                  Interfere with, disrupt, or create an undue burden on the
                  Services or the networks or services connected to the
                  Services.
                </span>
              </li>
              <li
                className="MsoNormal"
                style={{ lineHeight: '1.5', textAlign: 'left' }}
              >
                <span
                  style={{
                    fontSize: '15px',
                    lineHeight: '16.8667px',
                    color: 'rgb(89, 89, 89)',
                  }}
                >
                  Harass, annoy, intimidate, or threaten any of our employees or
                  agents engaged in providing any portion of the Services to
                  you.
                </span>
              </li>
              <li
                className="MsoNormal"
                style={{ lineHeight: '1.5', textAlign: 'left' }}
              >
                <span
                  style={{
                    fontSize: '15px',
                    lineHeight: '16.8667px',
                    color: 'rgb(89, 89, 89)',
                  }}
                >
                  Attempt to bypass any measures of the Services designed to
                  prevent or restrict access to the Services, or any portion of
                  the Services.
                </span>
              </li>
              <li
                className="MsoNormal"
                style={{ lineHeight: '1.5', textAlign: 'left' }}
              >
                <span
                  style={{
                    fontSize: '15px',
                    lineHeight: '16.8667px',
                    color: 'rgb(89, 89, 89)',
                  }}
                >
                  Copy or adapt the Services&apos; software, including but not
                  limited to Flash, PHP, HTML, JavaScript, or other code.
                </span>
              </li>
              <li
                className="MsoNormal"
                style={{ lineHeight: '1.5', textAlign: 'left' }}
              >
                <span
                  style={{
                    fontSize: '15px',
                    lineHeight: '16.8667px',
                    color: 'rgb(89, 89, 89)',
                  }}
                >
                  Except as permitted by applicable law, decipher, decompile,
                  disassemble, or reverse engineer any of the software
                  comprising or in any way making up a part of the Services.
                </span>
              </li>
              <li
                className="MsoNormal"
                style={{ lineHeight: '1.5', textAlign: 'left' }}
              >
                <span
                  style={{
                    fontSize: '15px',
                    lineHeight: '16.8667px',
                    color: 'rgb(89, 89, 89)',
                  }}
                >
                  Except as may be the result of standard search engine or
                  Internet browser usage, use, launch, develop, or distribute
                  any automated system, including without limitation, any
                  spider, robot, cheat utility, scraper, or offline reader that
                  accesses the Services, or use or launch any unauthorized
                  script or other software.
                </span>
              </li>
              <li
                className="MsoNormal"
                style={{ lineHeight: '1.5', textAlign: 'left' }}
              >
                <span
                  style={{
                    fontSize: '15px',
                    lineHeight: '16.8667px',
                    color: 'rgb(89, 89, 89)',
                  }}
                >
                  Use a buying agent or purchasing agent to make purchases on
                  the Services.
                </span>
              </li>
              <li
                className="MsoNormal"
                style={{ lineHeight: '1.5', textAlign: 'left' }}
              >
                <span
                  style={{
                    fontSize: '15px',
                    lineHeight: '16.8667px',
                    color: 'rgb(89, 89, 89)',
                  }}
                >
                  Make any unauthorized use of the Services, including
                  collecting usernames and/or email addresses of users by
                  electronic or other means for the purpose of sending
                  unsolicited email, or creating user accounts by automated
                  means or under false pretenses.
                </span>
              </li>
              <li
                className="MsoNormal"
                style={{ lineHeight: '1.5', textAlign: 'left' }}
              >
                <span
                  style={{
                    fontSize: '15px',
                    lineHeight: '16.8667px',
                    color: 'rgb(89, 89, 89)',
                  }}
                >
                  Use the Services as part of any effort to compete with us or
                  otherwise use the Services and/or the Content for any
                  revenue-generating endeavor or commercial enterprise.
                </span>
              </li>
            </ul>

            <div className="MsoNormal">
              <br />
            </div>

            <div className="MsoNormal" id="ugc" style={{ lineHeight: '1.5' }}>
              <strong>
                <span style={{ lineHeight: '1.5', fontSize: '19px' }}>
                  <h2>6. USER GENERATED CONTRIBUTIONS</h2>
                </span>
              </strong>
            </div>

            <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
              <span
                style={{
                  fontSize: '11pt',
                  lineHeight: '16.8667px',
                  color: 'rgb(89, 89, 89)',
                }}
              >
                The Services may invite you to chat, contribute to, or
                participate in blogs, message boards, online forums, and other
                functionality, and may provide you with the opportunity to
                create, submit, post, display, transmit, perform, publish,
                distribute, or broadcast content and materials to us or on the
                Services, including but not limited to text, writings, video,
                audio, photographs, graphics, comments, suggestions, or personal
                information or other material (collectively, Contributions).
                Contributions may be viewable by other users of the Services and
                through third-party websites. As such, any Contributions you
                transmit may be treated as non-confidential and non-proprietary.
                When you create or make available any Contributions, you thereby
                represent and warrant that:
              </span>
            </div>
          </div>
        </div>

        <div className="MsoNormal" style={{ lineHeight: '17.25px' }}>
          <ul style={listStyle}>
            <li style={{ lineHeight: '1.5' }}>
              <span style={{ color: 'rgb(89, 89, 89)', fontSize: '14px' }}>
                The creation, distribution, transmission, public display, or
                performance, and the accessing, downloading, or copying of your
                Contributions do not and will not infringe the proprietary
                rights, including but not limited to the copyright, patent,
                trademark, trade secret, or moral rights of any third party.
              </span>
            </li>
            <li style={{ lineHeight: '1.5' }}>
              <span style={{ color: 'rgb(89, 89, 89)', fontSize: '14px' }}>
                You are the creator and owner of or have the necessary licenses,
                rights, consents, releases, and permissions to use and to
                authorize us, the Services, and other users of the Services to
                use your Contributions in any manner contemplated by the
                Services and these Legal Terms.
              </span>
            </li>
            <li style={{ lineHeight: '1.5' }}>
              <span style={{ color: 'rgb(89, 89, 89)', fontSize: '14px' }}>
                You have the written consent, release, and/or permission of each
                and every identifiable individual person in your Contributions
                to use the name or likeness of each and every such identifiable
                individual person to enable inclusion and use of your
                Contributions in any manner contemplated by the Services and
                these Legal Terms.
              </span>
            </li>
            <li style={{ lineHeight: '1.5' }}>
              <span style={{ color: 'rgb(89, 89, 89)', fontSize: '14px' }}>
                Your Contributions are not false, inaccurate, or misleading.
              </span>
            </li>
            <li style={{ lineHeight: '1.5' }}>
              <span style={{ color: 'rgb(89, 89, 89)', fontSize: '14px' }}>
                Your Contributions are not unsolicited or unauthorized
                advertising, promotional materials, pyramid schemes, chain
                letters, spam, mass mailings, or other forms of solicitation.
              </span>
            </li>
            <li style={{ lineHeight: '1.5' }}>
              <span style={{ color: 'rgb(89, 89, 89)', fontSize: '14px' }}>
                Your Contributions are not obscene, lewd, lascivious, filthy,
                violent, harassing, libelous, slanderous, or otherwise
                objectionable (as determined by us).
              </span>
            </li>
            <li style={{ lineHeight: '1.5' }}>
              <span style={{ color: 'rgb(89, 89, 89)', fontSize: '14px' }}>
                Your Contributions do not ridicule, mock, disparage, intimidate,
                or abuse anyone.
              </span>
            </li>
            <li style={{ lineHeight: '1.5' }}>
              <span style={{ color: 'rgb(89, 89, 89)', fontSize: '14px' }}>
                Your Contributions are not used to harass or threaten (in the
                legal sense of those terms) any other person and to promote
                violence against a specific person or class of people.
              </span>
            </li>
            <li style={{ lineHeight: '1.5' }}>
              <span style={{ color: 'rgb(89, 89, 89)', fontSize: '14px' }}>
                Your Contributions do not violate any applicable law,
                regulation, or rule.
              </span>
            </li>
            <li style={{ lineHeight: '1.5' }}>
              <span style={{ color: 'rgb(89, 89, 89)', fontSize: '14px' }}>
                Your Contributions do not violate the privacy or publicity
                rights of any third party.
              </span>
            </li>
            <li style={{ lineHeight: '1.5' }}>
              <span style={{ color: 'rgb(89, 89, 89)', fontSize: '14px' }}>
                Your Contributions do not violate any applicable law concerning
                child pornography, or otherwise intended to protect the health
                or well-being of minors.
              </span>
            </li>
            <li style={{ lineHeight: '1.5' }}>
              <span style={{ color: 'rgb(89, 89, 89)', fontSize: '14px' }}>
                Your Contributions do not include any offensive comments that
                are connected to race, national origin, gender, sexual
                preference, or physical handicap.
              </span>
            </li>
            <li style={{ lineHeight: '1.5' }}>
              <span style={{ color: 'rgb(89, 89, 89)', fontSize: '14px' }}>
                Your Contributions do not otherwise violate, or link to material
                that violates, any provision of these Legal Terms, or any
                applicable law or regulation.
              </span>
            </li>
          </ul>

          <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
            <span
              style={{
                fontSize: '11pt',
                lineHeight: '16.8667px',
                color: 'rgb(89, 89, 89)',
              }}
            >
              Any use of the Services in violation of the foregoing violates
              these Legal Terms and may result in, among other things,
              termination or suspension of your rights to use the Services.
            </span>
          </div>
        </div>

        <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div
          className="MsoNormal"
          style={{ textAlign: 'justify', lineHeight: '1' }}
        >
          <div className="MsoNormal" id="license" style={{ lineHeight: '1.5' }}>
            <strong>
              <span style={{ lineHeight: '1.5', fontSize: '19px' }}>
                <h2>7. CONTRIBUTION LICENSE</h2>
              </span>
            </strong>
          </div>
        </div>

        <div className="MsoNormal" style={{ lineHeight: '1' }}>
          <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
            <span
              style={{
                fontSize: '11pt',
                lineHeight: '16.8667px',
                color: 'rgb(89, 89, 89)',
              }}
            >
              By posting your Contributions to any part of the Services, you
              automatically grant, and you represent and warrant that you have
              the right to grant, to us an unrestricted, unlimited, irrevocable,
              perpetual, non-exclusive, transferable, royalty-free, fully-paid,
              worldwide right, and license to host, use, copy, reproduce,
              disclose, sell, resell, publish, broadcast, retitle, archive,
              store, cache, publicly perform, publicly display, reformat,
              translate, transmit, excerpt (in whole or in part), and distribute
              such Contributions (including, without limitation, your image and
              voice) for any purpose, commercial, advertising, or otherwise, and
              to prepare derivative works of, or incorporate into other works,
              such Contributions, and grant and authorize sublicenses of the
              foregoing. The use and distribution may occur in any media formats
              and through any media channels.
            </span>
          </div>
        </div>

        <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div
          className="MsoNormal"
          style={{ textAlign: 'justify', lineHeight: '1' }}
        >
          <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
            <span
              style={{
                fontSize: '11pt',
                lineHeight: '16.8667px',
                color: 'rgb(89, 89, 89)',
              }}
            >
              This license will apply to any form, media, or technology now
              known or hereafter developed, and includes our use of your name,
              company name, and franchise name, as applicable, and any of the
              trademarks, service marks, trade names, logos, and personal and
              commercial images you provide. You waive all moral rights in your
              Contributions, and you warrant that moral rights have not
              otherwise been asserted in your Contributions.
            </span>
          </div>
        </div>

        <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div
          className="MsoNormal"
          style={{ textAlign: 'justify', lineHeight: '1' }}
        >
          <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
            <span
              style={{
                fontSize: '11pt',
                lineHeight: '16.8667px',
                color: 'rgb(89, 89, 89)',
              }}
            >
              We do not assert any ownership over your Contributions. You retain
              full ownership of all of your Contributions and any intellectual
              property rights or other proprietary rights associated with your
              Contributions. We are not liable for any statements or
              representations in your Contributions provided by you in any area
              on the Services. You are solely responsible for your Contributions
              to the Services and you expressly agree to exonerate us from any
              and all responsibility and to refrain from any legal action
              against us regarding your Contributions.
            </span>
          </div>
        </div>

        <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div
          className="MsoNormal"
          style={{ textAlign: 'justify', lineHeight: '1' }}
        >
          <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
            <span
              style={{
                fontSize: '11pt',
                lineHeight: '16.8667px',
                color: 'rgb(89, 89, 89)',
              }}
            >
              We have the right, in our sole and absolute discretion, (1) to
              edit, redact, or otherwise change any Contributions; (2) to
              re-categorize any Contributions to place them in more appropriate
              locations on the Services; and (3) to pre-screen or delete any
              Contributions at any time and for any reason, without notice. We
              have no obligation to monitor your Contributions.
            </span>
          </div>
        </div>
      </div>

      <div style={{ textAlign: 'left' }}>
        <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div className="MsoNormal" id="mobile" style={heading1Style}>
          <strong>
            <h2>8. MOBILE APPLICATION LICENSE</h2>
          </strong>
        </div>

        <div className="MsoNormal" style={heading2Style}>
          <strong>
            <h3>Use License</h3>
          </strong>
        </div>

        <div
          className="MsoNormal"
          style={{ lineHeight: '1.5', textAlign: 'left' }}
        >
          <span
            style={{
              fontSize: '11pt',
              lineHeight: '16.8667px',
              color: 'rgb(89, 89, 89)',
            }}
          >
            If you access the Services via the App, then we grant you a
            revocable, non-exclusive, non-transferable, limited right to install
            and use the App on wireless electronic devices owned or controlled
            by you, and to access and use the App on such devices strictly in
            accordance with the terms and conditions of this mobile application
            license contained in these Legal Terms. You shall not: (1) except as
            permitted by applicable law, decompile, reverse engineer,
            disassemble, attempt to derive the source code of, or decrypt the
            App; (2) make any modification, adaptation, improvement,
            enhancement, translation, or derivative work from the App; (3)
            violate any applicable laws, rules, or regulations in connection
            with your access or use of the App; (4) remove, alter, or obscure
            any proprietary notice (including any notice of copyright or
            trademark) posted by us or the licensors of the App; (5) use the App
            for any revenue-generating endeavor, commercial enterprise, or other
            purpose for which it is not designed or intended; (6) make the App
            available over a network or other environment permitting access or
            use by multiple devices or users at the same time; (7) use the App
            for creating a product, service, or software that is, directly or
            indirectly, competitive with or in any way a substitute for the App;
            (8) use the App to send automated queries to any website or to send
            any unsolicited commercial email; or (9) use any proprietary
            information or any of our interfaces or our other intellectual
            property in the design, development, manufacture, licensing, or
            distribution of any applications, accessories, or devices for use
            with the App.
          </span>
        </div>

        <div className="MsoNormal" style={heading2Style}>
          <span
            style={{
              fontSize: '11pt',
              lineHeight: '1.5',
              color: 'rgb(89, 89, 89)',
            }}
          >
            <strong>
              <h3>Apple and Android Devices</h3>
            </strong>
          </span>
        </div>

        <div
          className="MsoNormal"
          style={{ lineHeight: '1.5', textAlign: 'left' }}
        >
          <span
            style={{
              fontSize: '11pt',
              lineHeight: '16.8667px',
              color: 'rgb(89, 89, 89)',
            }}
          >
            The following terms apply when you use the App obtained from either
            the Apple Store or Google Play (each an App Distributor) to access
            the Services: (1) the license granted to you for our App is limited
            to a non-transferable license to use the application on a device
            that utilizes the Apple iOS or Android operating systems, as
            applicable, and in accordance with the usage rules set forth in the
            applicable App Distributor&apos;s terms of service; (2) we are
            responsible for providing any maintenance and support services with
            respect to the App as specified in the terms and conditions of this
            mobile application license contained in these Legal Terms or as
            otherwise required under applicable law, and you acknowledge that
            each App Distributor has no obligation whatsoever to furnish any
            maintenance and support services with respect to the App; (3) in the
            event of any failure of the App to conform to any applicable
            warranty, you may notify the applicable App Distributor, and the App
            Distributor, in accordance with its terms and policies, may refund
            the purchase price, if any, paid for the App, and to the maximum
            extent permitted by applicable law, the App Distributor will have no
            other warranty obligation whatsoever with respect to the App; (4)
            you represent and warrant that (i) you are not located in a country
            that is subject to a US government embargo, or that has been
            designated by the US government as a terrorist supporting country
            and (ii) you are not listed on any US government list of prohibited
            or restricted parties; (5) you must comply with applicable
            third-party terms of agreement when using the App, e.g., if you have
            a VoIP application, then you must not be in violation of their
            wireless data service agreement when using the App; and (6) you
            acknowledge and agree that the App Distributors are third-party
            beneficiaries of the terms and conditions in this mobile application
            license contained in these Legal Terms, and that each App
            Distributor will have the right (and will be deemed to have accepted
            the right) to enforce the terms and conditions in this mobile
            application license contained in these Legal Terms against you as a
            third-party beneficiary thereof.
          </span>
        </div>

        <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div className="MsoNormal" id="sitemanage" style={heading1Style}>
          <strong>
            <span style={{ lineHeight: '1.5', fontSize: '19px' }}>
              <h2>9. SERVICES MANAGEMENT</h2>
            </span>
          </strong>
        </div>

        <div
          className="MsoNormal"
          style={{ lineHeight: '1.5', textAlign: 'left' }}
        >
          We reserve the right, but not the obligation, to: (1) monitor the
          Services for violations of these Legal Terms; (2) take appropriate
          legal action against anyone who, in our sole discretion, violates the
          law or these Legal Terms, including without limitation, reporting such
          user to law enforcement authorities; (3) in our sole discretion and
          without limitation, refuse, restrict access to, limit the availability
          of, or disable (to the extent technologically feasible) any of your
          Contributions or any portion thereof; (4) in our sole discretion and
          without limitation, notice, or liability, to remove from the Services
          or otherwise disable all files and content that are excessive in size
          or are in any way burdensome to our systems; and (5) otherwise manage
          the Services in a manner designed to protect our rights and property
          and to facilitate the proper functioning of the Services.
        </div>

        <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div className="MsoNormal" id="ppno" style={heading1Style}>
          <strong>
            <h2>10. PRIVACY POLICY</h2>
          </strong>
        </div>

        <div
          className="MsoNormal"
          style={{ lineHeight: '1.5', textAlign: 'left' }}
        >
          <span
            style={{
              fontSize: '11pt',
              lineHeight: '16.8667px',
              color: 'rgb(89, 89, 89)',
            }}
          >
            We care about data privacy and security. By using the Services, you
            agree to be bound by our Privacy Policy posted on the Services,
            which is incorporated into these Legal Terms. Please be advised the
            Services are hosted in the United States. If you access the Services
            from any other region of the world with laws or other requirements
            governing personal data collection, use, or disclosure that differ
            from applicable laws in the United States, then through your
            continued use of the Services, you are transferring your data to the
            United States, and you expressly consent to have your data
            transferred to and processed in the United States.
          </span>
        </div>

        <div className="MsoNormal" style={{ lineHeight: '1.5' }}>
          <br />
        </div>

        <div className="MsoNormal" id="terms" style={heading1Style}>
          <strong>
            <span style={{ lineHeight: '1.5', fontSize: '19px' }}>
              <h2>11. TERM AND TERMINATION</h2>
            </span>
          </strong>
        </div>

        <div
          className="MsoNormal"
          style={{ lineHeight: '1.5', textAlign: 'left' }}
        >
          <span
            style={{
              fontSize: '11pt',
              lineHeight: '16.8667px',
              color: 'rgb(89, 89, 89)',
            }}
          >
            These Legal Terms shall remain in full force and effect while you
            use the Services. WITHOUT LIMITING ANY OTHER PROVISION OF THESE
            LEGAL TERMS, WE RESERVE THE RIGHT TO, IN OUR SOLE DISCRETION AND
            WITHOUT NOTICE OR LIABILITY, DENY ACCESS TO AND USE OF THE SERVICES
            (INCLUDING BLOCKING CERTAIN IP ADDRESSES), TO ANY PERSON FOR ANY
            REASON OR FOR NO REASON, INCLUDING WITHOUT LIMITATION FOR BREACH OF
            ANY REPRESENTATION, WARRANTY, OR COVENANT CONTAINED IN THESE LEGAL
            TERMS OR OF ANY APPLICABLE LAW OR REGULATION. WE MAY TERMINATE YOUR
            USE OR PARTICIPATION IN THE SERVICES OR DELETE YOUR ACCOUNT AND ANY
            CONTENT OR INFORMATION THAT YOU POSTED AT ANY TIME, WITHOUT WARNING,
            IN OUR SOLE DISCRETION.
          </span>
        </div>

        <div
          className="MsoNormal"
          style={{ lineHeight: '1.5', textAlign: 'left' }}
        >
          <br />
        </div>

        <div
          className="MsoNormal"
          style={{ lineHeight: '1.5', textAlign: 'left' }}
        >
          <span
            style={{
              fontSize: '1pt',
              lineHeight: '16.8667px',
              color: 'rgb(89, 89, 89)',
            }}
          >
            If we terminate or suspend your account for any reason, you are
            prohibited from registering and creating a new account under your
            name, a fake or borrowed name, or the name of any third party, even
            if you may be acting on behalf of the third party. In addition to
            terminating or suspending your account, we reserve the right to take
            appropriate legal action, including without limitation pursuing
            civil, criminal, and injunctive redress.
          </span>
        </div>

        <div
          className="MsoNormal"
          style={{ lineHeight: '1.5', textAlign: 'left' }}
        >
          <br />
        </div>

        <div className="MsoNormal" id="modifications" style={heading1Style}>
          <strong>
            <span style={{ lineHeight: '1.5', fontSize: '19px' }}>
              <h2>12. MODIFICATIONS AND INTERRUPTIONS</h2>
            </span>
          </strong>
        </div>

        <div
          className="MsoNormal"
          style={{ lineHeight: '1.5', textAlign: 'left' }}
        >
          <span
            style={{
              fontSize: '11pt',
              lineHeight: '16.8667px',
              color: 'rgb(89, 89, 89)',
            }}
          >
            We reserve the right to change, modify, or remove the contents of
            the Services at any time or for any reason at our sole discretion
            without notice. However, we have no obligation to update any
            information on our Services. We will not be liable to you or any
            third party for any modification, price change, suspension, or
            discontinuance of the Services.
          </span>
        </div>

        <div
          className="MsoNormal"
          style={{ lineHeight: '1.5', textAlign: 'left' }}
        >
          <br />
        </div>

        <div
          className="MsoNormal"
          style={{ lineHeight: '1.5', textAlign: 'left' }}
        >
          <span
            style={{
              fontSize: '11pt',
              lineHeight: '16.8667px',
              color: 'rgb(89, 89, 89)',
            }}
          >
            We cannot guarantee the Services will be available at all times. We
            may experience hardware, software, or other problems or need to
            perform maintenance related to the Services, resulting in
            interruptions, delays, or errors. We reserve the right to change,
            revise, update, suspend, discontinue, or otherwise modify the
            Services at any time or for any reason without notice to you. You
            agree that we have no liability whatsoever for any loss, damage, or
            inconvenience caused by your inability to access or use the Services
            during any downtime or discontinuance of the Services. Nothing in
            these Legal Terms will be construed to obligate us to maintain and
            support the Services or to supply any corrections, updates, or
            releases in connection therewith.
          </span>
        </div>

        <div
          className="MsoNormal"
          style={{ lineHeight: '1.5', textAlign: 'left' }}
        >
          <br />
        </div>

        <div className="MsoNormal" id="law" style={heading1Style}>
          <strong>
            <span style={{ lineHeight: '1.5', fontSize: '19px' }}>
              <h2>13. GOVERNING LAW</h2>
            </span>
          </strong>
        </div>

        <div
          className="MsoNormal"
          style={{ lineHeight: '1.5', textAlign: 'left' }}
        >
          <span
            style={{
              fontSize: '11pt',
              lineHeight: '16.8667px',
              color: 'rgb(89, 89, 89)',
            }}
          >
            These Legal Terms and your use of the Services are governed by and
            construed in accordance with the laws of the State of Nevada
            applicable to agreements made and to be entirely performed within
            the State of Nevada, without regard to its conflict of law
            principles.
          </span>
        </div>

        <div
          className="MsoNormal"
          style={{ lineHeight: '1.5', textAlign: 'left' }}
        >
          <br />
        </div>

        <div className="MsoNormal" id="disputes" style={heading1Style}>
          <strong>
            <span style={{ lineHeight: '1.5', fontSize: '19px' }}>
              <h2>14. DISPUTE RESOLUTION</h2>
            </span>
          </strong>
        </div>

        <div className="MsoNormal" style={heading2Style}>
          <strong>
            <h3>Informal Negotiations</h3>
          </strong>
        </div>

        <div
          className="MsoNormal"
          style={{ lineHeight: '1.5', textAlign: 'left' }}
        >
          <span style={{ fontSize: '15px' }}>
            To expedite resolution and control the cost of any dispute,
            controversy, or claim related to these Legal Terms (each a Dispute
            and collectively, the Disputes) brought by either you or us
            (individually, a Party and collectively, the Parties), the Parties
            agree to first attempt to negotiate any Dispute (except those
            Disputes expressly provided below) informally for at least thirty
            (30) days before initiating arbitration. Such informal negotiations
            commence upon written notice from one Party to the other Party.
          </span>
        </div>

        <div className="MsoNormal" style={heading2Style}>
          <strong>
            <h3>Binding Arbitration</h3>
          </strong>
        </div>

        <div
          className="MsoNormal"
          style={{ lineHeight: '1.5', textAlign: 'left' }}
        >
          <span style={{ fontSize: '15px' }}>
            If the Parties are unable to resolve a Dispute through informal
            negotiations, the Dispute (except those Disputes expressly excluded
            below) will be finally and exclusively resolved by binding
            arbitration. YOU UNDERSTAND THAT WITHOUT THIS PROVISION, YOU WOULD
            HAVE THE RIGHT TO SUE IN COURT AND HAVE A JURY TRIAL. The
            arbitration shall be commenced and conducted under the Commercial
            Arbitration Rules of the American Arbitration Association (AAA) and,
            where appropriate, the AAA&apos;s Supplementary Procedures for
            Consumer Related Disputes (AAA Consumer Rules), both of which are
            available at the American Arbitration Association (AAA) website.
            Your arbitration fees and your share of arbitrator compensation
            shall be governed by the AAA Consumer Rules and, where appropriate,
            limited by the AAA Consumer Rules. The arbitration may be conducted
            in person, through the submission of documents, by phone, or online.
            The arbitrator will make a decision in writing, but need not provide
            a statement of reasons unless requested by either Party. The
            arbitrator must follow applicable law, and any award may be
            challenged if the arbitrator fails to do so. Except where otherwise
            required by the applicable AAA rules or applicable law, the
            arbitration will take place in Clark County, Nevada. Except as
            otherwise provided herein, the Parties may litigate in court to
            compel arbitration, stay proceedings pending arbitration, or to
            confirm, modify, vacate, or enter judgment on the award entered by
            the arbitrator.
          </span>
        </div>

        <div
          className="MsoNormal"
          style={{ lineHeight: '1.5', textAlign: 'left' }}
        >
          <br />
        </div>

        <div
          className="MsoNormal"
          style={{ lineHeight: '1.5', textAlign: 'left' }}
        >
          <span style={{ fontSize: '15px' }}>
            If for any reason, a Dispute proceeds in court rather than
            arbitration, the Dispute shall be commenced or prosecuted in the
            state and federal courts located in Clark County, Nevada, and the
            Parties hereby consent to, and waive all defenses of lack of
            personal jurisdiction, and forum non conveniens with respect to
            venue and jurisdiction in such state and federal courts. Application
            of the United Nations Convention on Contracts for the International
            Sale of Goods and the Uniform Computer Information Transaction Act
            (UCITA) are excluded from these Legal Terms.
          </span>
        </div>

        <div
          className="MsoNormal"
          style={{ lineHeight: '1.5', textAlign: 'left' }}
        >
          <br />
        </div>

        <div
          className="MsoNormal"
          style={{ lineHeight: '1.5', textAlign: 'left' }}
        >
          <span style={{ fontSize: '15px' }}>
            In no event shall any Dispute brought by either Party related in any
            way to the Services be commenced more than one (1) years after the
            cause of action arose. If this provision is found to be illegal or
            unenforceable, then neither Party will elect to arbitrate any
            Dispute falling within that portion of this provision found to be
            illegal or unenforceable and such Dispute shall be decided by a
            court of competent jurisdiction within the courts listed for
            jurisdiction above, and the Parties agree to submit to the personal
            jurisdiction of that court.
          </span>
        </div>

        <div className="MsoNormal" style={heading2Style}>
          <strong>
            <h3>Restrictions</h3>
          </strong>
        </div>

        <div
          className="MsoNormal"
          style={{ lineHeight: '1.5', textAlign: 'left' }}
        >
          The Parties agree that any arbitration shall be limited to the Dispute
          between the Parties individually. To the full extent permitted by law,
          (a) no arbitration shall be joined with any other proceeding; (b)
          there is no right or authority for any Dispute to be arbitrated on a
          class-action basis or to utilize class action procedures; and (c)
          there is no right or authority for any Dispute to be brought in a
          purported representative capacity on behalf of the general public or
          any other persons.
        </div>

        <div className="MsoNormal" style={heading2Style}>
          <strong>
            <h3>Exceptions to Informal Negotiations and Arbitration</h3>
          </strong>
        </div>

        <div
          className="MsoNormal"
          style={{ lineHeight: '1.5', textAlign: 'left' }}
        >
          The Parties agree that the following Disputes are not subject to the
          above provisions concerning informal negotiations binding arbitration:
          (a) any Disputes seeking to enforce or protect, or concerning the
          validity of, any of the intellectual property rights of a Party; (b)
          any Dispute related to, or arising from, allegations of theft, piracy,
          invasion of privacy, or unauthorized use; and (c) any claim for
          injunctive relief. If this provision is found to be illegal or
          unenforceable, then neither Party will elect to arbitrate any Dispute
          falling within that portion of this provision found to be illegal or
          unenforceable and such Dispute shall be decided by a court of
          competent jurisdiction within the courts listed for jurisdiction
          above, and the Parties agree to submit to the personal jurisdiction of
          that court.
        </div>

        <div
          className="MsoNormal"
          style={{ lineHeight: '1.5', textAlign: 'left' }}
        >
          <br />
        </div>

        <div className="MsoNormal" id="corrections" style={heading1Style}>
          <strong>
            <span style={{ fontSize: '19px', lineHeight: '1.5' }}>
              <h2>15. CORRECTIONS</h2>
            </span>
          </strong>
        </div>

        <div
          className="MsoNormal"
          style={{ lineHeight: '1.5', textAlign: 'left' }}
        >
          There may be information on the Services that contains typographical
          errors, inaccuracies, or omissions, including descriptions, pricing,
          availability, and various other information. We reserve the right to
          correct any errors, inaccuracies, or omissions and to change or update
          the information on the Services at any time, without prior notice.
        </div>

        <div
          className="MsoNormal"
          style={{ lineHeight: '1.5', textAlign: 'left' }}
        >
          <br />
        </div>

        <div className="MsoNormal" id="disclaimer" style={heading1Style}>
          <span
            style={{
              fontSize: '19px',
              lineHeight: '1.5',
              color: 'rgb(0, 0, 0)',
            }}
          >
            <strong>
              <h2>16. DISCLAIMER</h2>
            </strong>
          </span>
        </div>

        <div
          className="MsoNormal"
          style={{ lineHeight: '1.5', textAlign: 'left' }}
        >
          <span
            style={{
              fontSize: '11pt',
              lineHeight: '15%',
              fontFamily: 'Arial',
              color: '#595959',
            }}
          >
            THE SERVICES ARE PROVIDED ON AN AS-IS AND AS-AVAILABLE BASIS. YOU
            AGREE THAT YOUR USE OF THE SERVICES WILL BE AT YOUR SOLE RISK. TO
            THE FULLEST EXTENT PERMITTED BY LAW, WE DISCLAIM ALL WARRANTIES,
            EXPRESS OR IMPLIED, IN CONNECTION WITH THE SERVICES AND YOUR USE
            THEREOF, INCLUDING, WITHOUT LIMITATION, THE IMPLIED WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND
            NON-INFRINGEMENT. WE MAKE NO WARRANTIES OR REPRESENTATIONS ABOUT THE
            ACCURACY OR COMPLETENESS OF THE SERVICES&apos; CONTENT OR THE
            CONTENT OF ANY WEBSITES OR MOBILE APPLICATIONS LINKED TO THE
            SERVICES AND WE WILL ASSUME NO LIABILITY OR RESPONSIBILITY FOR ANY
            (1) ERRORS, MISTAKES, OR INACCURACIES OF CONTENT AND MATERIALS, (2)
            PERSONAL INJURY OR PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER,
            RESULTING FROM YOUR ACCESS TO AND USE OF THE SERVICES, (3) ANY
            UNAUTHORIZED ACCESS TO OR USE OF OUR SECURE SERVERS AND/OR ANY AND
            ALL PERSONAL INFORMATION AND/OR FINANCIAL INFORMATION STORED
            THEREIN, (4) ANY INTERRUPTION OR CESSATION OF TRANSMISSION TO OR
            FROM THE SERVICES, (5) ANY BUGS, VIRUSES, TROJAN HORSES, OR THE LIKE
            WHICH MAY BE TRANSMITTED TO OR THROUGH THE SERVICES BY ANY THIRD
            PARTY, AND/OR (6) ANY ERRORS OR OMISSIONS IN ANY CONTENT AND
            MATERIALS OR FOR ANY LOSS OR DAMAGE OF ANY KIND INCURRED AS A RESULT
            OF THE USE OF ANY CONTENT POSTED, TRANSMITTED, OR OTHERWISE MADE
            AVAILABLE VIA THE SERVICES. WE DO NOT WARRANT, ENDORSE, GUARANTEE,
            OR ASSUME RESPONSIBILITY FOR ANY PRODUCT OR SERVICE ADVERTISED OR
            OFFERED BY A THIRD PARTY THROUGH THE SERVICES, ANY HYPERLINKED
            WEBSITE, OR ANY WEBSITE OR MOBILE APPLICATION FEATURED IN ANY BANNER
            OR OTHER ADVERTISING, AND WE WILL NOT BE A PARTY TO OR IN ANY WAY BE
            RESPONSIBLE FOR MONITORING ANY TRANSACTION BETWEEN YOU AND ANY
            THIRD-PARTY PROVIDERS OF PRODUCTS OR SERVICES. AS WITH THE PURCHASE
            OF A PRODUCT OR SERVICE THROUGH ANY MEDIUM OR IN ANY ENVIRONMENT,
            YOU SHOULD USE YOUR BEST JUDGMENT AND EXERCISE CAUTION WHERE
            APPROPRIATE.
          </span>
        </div>

        <div
          className="MsoNormal"
          style={{ lineHeight: '1.5', textAlign: 'left' }}
        >
          <br />
        </div>

        <div className="MsoNormal" id="liability" style={heading1Style}>
          <strong>
            <span
              style={{
                lineHeight: '1.5',
                fontFamily: 'Arial',
                fontSize: '19px',
              }}
            >
              <h2>17. LIMITATIONS OF LIABILITY</h2>
            </span>
          </strong>
        </div>

        <div
          className="MsoNormal"
          style={{ lineHeight: '1.5', textAlign: 'left' }}
        >
          <span
            style={{
              fontSize: '11pt',
              lineHeight: '115%',
              fontFamily: 'Arial',
              color: '#595959',
            }}
          >
            IN NO EVENT WILL WE OR OUR DIRECTORS, EMPLOYEES, OR AGENTS BE LIABLE
            TO YOU OR ANY THIRD PARTY FOR ANY DIRECT, INDIRECT, CONSEQUENTIAL,
            EXEMPLARY, INCIDENTAL, SPECIAL, OR PUNITIVE DAMAGES, INCLUDING LOST
            PROFIT, LOST REVENUE, LOSS OF DATA, OR OTHER DAMAGES ARISING FROM
            YOUR USE OF THE SERVICES, EVEN IF WE HAVE BEEN ADVISED OF THE
            POSSIBILITY OF SUCH DAMAGES. NOTWITHSTANDING ANYTHING TO THE
            CONTRARY CONTAINED HEREIN, OUR LIABILITY TO YOU FOR ANY CAUSE
            WHATSOEVER AND REGARDLESS OF THE FORM OF THE ACTION, WILL AT ALL
            TIMES BE LIMITED TO THE AMOUNT PAID, IF ANY, BY YOU TO US. CERTAIN
            US STATE LAWS AND INTERNATIONAL LAWS DO NOT ALLOW LIMITATIONS ON
            IMPLIED WARRANTIES OR THE EXCLUSION OR LIMITATION OF CERTAIN
            DAMAGES. IF THESE LAWS APPLY TO YOU, SOME OR ALL OF THE ABOVE
            DISCLAIMERS OR LIMITATIONS MAY NOT APPLY TO YOU, AND YOU MAY HAVE
            ADDITIONAL RIGHTS.
          </span>
        </div>

        <div
          className="MsoNormal"
          style={{ lineHeight: '1.5', textAlign: 'left' }}
        >
          <br />
        </div>

        <div className="MsoNormal" id="indemnification" style={heading1Style}>
          <strong>
            <span
              style={{
                lineHeight: '1.5',
                fontFamily: 'Arial',
                fontSize: '19px',
              }}
            >
              <h2>18. INDEMNIFICATION</h2>
            </span>
          </strong>
        </div>

        <div
          className="MsoNormal"
          style={{ lineHeight: '1.5', textAlign: 'left' }}
        >
          <span
            style={{
              fontSize: '11pt',
              lineHeight: '115%',
              fontFamily: 'Arial',
              color: '#595959',
            }}
          >
            You agree to defend, indemnify, and hold us harmless, including our
            subsidiaries, affiliates, and all of our respective officers,
            agents, partners, and employees, from and against any loss, damage,
            liability, claim, or demand, including reasonable attorneys&apos;
            fees and expenses, made by any third party due to or arising out of:
            (1) your Contributions; (2) use of the Services; (3) breach of these
            Legal Terms; (4) any breach of your representations and warranties
            set forth in these Legal Terms; (5) your violation of the rights of
            a third party, including but not limited to intellectual property
            rights; or (6) any overt harmful act toward any other user of the
            Services with whom you connected via the Services. Notwithstanding
            the foregoing, we reserve the right, at your expense, to assume the
            exclusive defense and control of any matter for which you are
            required to indemnify us, and you agree to cooperate, at your
            expense, with our defense of such claims. We will use reasonable
            efforts to notify you of any such claim, action, or proceeding which
            is subject to this indemnification upon becoming aware of it.
          </span>
        </div>

        <div
          className="MsoNormal"
          style={{ lineHeight: '1.5', textAlign: 'left' }}
        >
          <br />
        </div>

        <div className="MsoNormal" id="userdata" style={heading1Style}>
          <strong>
            <span
              style={{
                lineHeight: '1.5',
                fontFamily: 'Arial',
                fontSize: '19px',
              }}
            >
              <h2>19. USER DATA</h2>
            </span>
          </strong>
        </div>

        <div
          className="MsoNormal"
          style={{ lineHeight: '1.5', textAlign: 'left' }}
        >
          <span
            style={{
              fontSize: '11pt',
              lineHeight: '115%',
              fontFamily: 'Arial',
              color: '#595959',
            }}
          >
            We will maintain certain data that you transmit to the Services for
            the purpose of managing the performance of the Services, as well as
            data relating to your use of the Services. Although we perform
            regular routine backups of data, you are solely responsible for all
            data that you transmit or that relates to any activity you have
            undertaken using the Services. You agree that we shall have no
            liability to you for any loss or corruption of any such data, and
            you hereby waive any right of action against us arising from any
            such loss or corruption of such data.
          </span>
        </div>

        <div
          className="MsoNormal"
          style={{ lineHeight: '1.5', textAlign: 'left' }}
        >
          <br />
        </div>

        <div className="MsoNormal" id="electronic" style={heading1Style}>
          <strong>
            <span
              style={{
                lineHeight: '1.5',
                fontFamily: 'Arial',
                fontSize: '19px',
              }}
            >
              <h2>
                20. ELECTRONIC COMMUNICATIONS, TRANSACTIONS, AND SIGNATURES
              </h2>
            </span>
          </strong>
        </div>

        <div
          className="MsoNormal"
          style={{ lineHeight: '1.5', textAlign: 'left' }}
        >
          <span
            style={{
              fontSize: '11pt',
              lineHeight: '115%',
              fontFamily: 'Arial',
              color: '#595959',
            }}
          >
            Visiting the Services, sending us emails, and completing online
            forms constitute electronic communications. You consent to receive
            electronic communications, and you agree that all agreements,
            notices, disclosures, and other communications we provide to you
            electronically, via email and on the Services, satisfy any legal
            requirement that such communication be in writing. YOU HEREBY AGREE
            TO THE USE OF ELECTRONIC SIGNATURES, CONTRACTS, ORDERS, AND OTHER
            RECORDS, AND TO ELECTRONIC DELIVERY OF NOTICES, POLICIES, AND
            RECORDS OF TRANSACTIONS INITIATED OR COMPLETED BY US OR VIA THE
            SERVICES. You hereby waive any rights or requirements under any
            statutes, regulations, rules, ordinances, or other laws in any
            jurisdiction which require an original signature or delivery or
            retention of non-electronic records, or to payments or the granting
            of credits by any means other than electronic means.
          </span>
        </div>

        <div
          className="MsoNormal"
          style={{ lineHeight: '1.5', textAlign: 'left' }}
        >
          <br />
        </div>

        <div className="MsoNormal" id="california" style={heading1Style}>
          <strong>
            <span
              style={{
                lineHeight: '1.5',
                fontFamily: 'Arial',
                fontSize: '19px',
              }}
            >
              <h2>21. CALIFORNIA USERS AND RESIDENTS</h2>
            </span>
          </strong>
        </div>

        <div
          className="MsoNormal"
          style={{ lineHeight: '1.5', textAlign: 'left' }}
        >
          <span
            style={{
              fontSize: '11pt',
              lineHeight: '115%',
              fontFamily: 'Arial',
              color: '#595959',
            }}
          >
            If any complaint with us is not satisfactorily resolved, you can
            contact the Complaint Assistance Unit of the Division of Consumer
            Services of the California Department of Consumer Affairs in writing
            at 1625 North Market Blvd., Suite N 112, Sacramento, California
            95834 or by telephone at (800) 952-5210 or (916) 445-1254.
          </span>
        </div>

        <div
          className="MsoNormal"
          style={{ lineHeight: '1.5', textAlign: 'left' }}
        >
          <br />
        </div>

        <div className="MsoNormal" id="misc" style={heading1Style}>
          <strong>
            <span
              style={{
                lineHeight: '1.5',
                fontFamily: 'Arial',
                fontSize: '19px',
              }}
            >
              <h2>22. MISCELLANEOUS</h2>
            </span>
          </strong>
        </div>

        <div
          className="MsoNormal"
          style={{ lineHeight: '1.5', textAlign: 'left' }}
        >
          <span
            style={{
              fontSize: '11pt',
              lineHeight: '115%',
              fontFamily: 'Arial',
              color: '#595959',
            }}
          >
            These Legal Terms and any policies or operating rules posted by us
            on the Services or in respect to the Services constitute the entire
            agreement and understanding between you and us. Our failure to
            exercise or enforce any right or provision of these Legal Terms
            shall not operate as a waiver of such right or provision. These
            Legal Terms operate to the fullest extent permissible by law. We may
            assign any or all of our rights and obligations to others at any
            time. We shall not be responsible or liable for any loss, damage,
            delay, or failure to act caused by any cause beyond our reasonable
            control. If any provision or part of a provision of these Legal
            Terms is determined to be unlawful, void, or unenforceable, that
            provision or part of the provision is deemed severable from these
            Legal Terms and does not affect the validity and enforceability of
            any remaining provisions. There is no joint venture, partnership,
            employment or agency relationship created between you and us as a
            result of these Legal Terms or use of the Services. You agree that
            these Legal Terms will not be construed against us by virtue of
            having drafted them. You hereby waive any and all defenses you may
            have based on the electronic form of these Legal Terms and the lack
            of signing by the parties hereto to execute these Legal Terms.
          </span>
        </div>

        <div
          className="MsoNormal"
          style={{ lineHeight: '1.5', textAlign: 'left' }}
        >
          <br />
        </div>

        <div className="MsoNormal" id="contact" style={heading1Style}>
          <strong>
            <span style={{ lineHeight: '115%', fontFamily: 'Arial' }}>
              <span style={{ fontSize: '19px', lineHeight: '1.5' }}>
                <h2>23. CONTACT US</h2>
              </span>
            </span>
          </strong>
        </div>

        <div
          className="MsoNormal"
          style={{ lineHeight: '1.5', textAlign: 'left' }}
        >
          <span
            style={{
              fontSize: '11pt',
              lineHeight: '115%',
              fontFamily: 'Arial',
              color: '#595959',
            }}
          >
            In order to resolve a complaint regarding the Services or to receive
            further information regarding use of the Services, please contact us
            at:
          </span>
        </div>

        <div
          className="MsoNormal"
          style={{ lineHeight: '1.5', textAlign: 'left' }}
        >
          <br />
        </div>

        <div
          className="MsoNormal"
          style={{ lineHeight: '1.5', textAlign: 'left' }}
        >
          <span style={{ fontSize: '15px' }}>
            <span style={{ color: 'rgb(89, 89, 89)' }}>
              <strong>MultiTax</strong>
            </span>
          </span>
        </div>

        <div
          className="MsoNormal"
          style={{ lineHeight: '1.5', textAlign: 'left' }}
        >
          <span style={{ fontSize: '15px' }}>
            <span
              style={{
                lineHeight: '15%',
                fontFamily: 'Arial',
                color: 'rgb(89, 89, 89)',
              }}
            >
              <strong>
                1725 S Rainbow Blvd suite 19, Las Vegas, NV 89146, USA
              </strong>
            </span>
          </span>
        </div>

        <div
          className="MsoNormal"
          style={{ lineHeight: '1.5', textAlign: 'left' }}
        >
          <span style={{ fontSize: '15px' }}>
            <strong>
              <span style={{ color: 'rgb(89, 89, 89)' }}>
                <strong>Las Vegas</strong>, <strong>NV</strong>{' '}
                <strong>89146</strong>
              </span>
            </strong>
          </span>
        </div>

        <div
          className="MsoNormal"
          style={{ lineHeight: '1.5', textAlign: 'left' }}
        >
          <span style={{ fontSize: '15px' }}>
            <strong>United States</strong>
          </span>
        </div>

        <div
          className="MsoNormal"
          style={{ lineHeight: '1.5', textAlign: 'left' }}
        >
          <strong>
            <span
              style={{
                fontSize: '11pt',
                lineHeight: '115%',
                fontFamily: 'Arial',
                color: '#595959',
              }}
            >
              <strong>Phone: (+1)7023376272</strong>
            </span>
          </strong>
        </div>

        <div
          className="MsoNormal"
          style={{ lineHeight: '1.5', textAlign: 'left' }}
        >
          <strong>
            <span
              style={{
                fontSize: '11pt',
                lineHeight: '15%',
                fontFamily: 'Arial',
                color: '#595959',
              }}
            >
              <strong>
                <a
                  href="mailto:multitaxpreparation@gmail.com"
                  style={linkStyle}
                >
                  multitaxpreparation@gmail.com
                </a>
              </strong>
            </span>
          </strong>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
